import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getItemFromRefList } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import _ from 'lodash';
import { t } from 'utils/translates';

class PointsTypeIdSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      titleSelectAll: t('Все операции'),
      value: this.getVerifiedPropStartValue()
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.value !== prevState.value) {
      this.props.handleChangeValue(this.state.value);
    }
  }

  getVerifiedPropStartValue = () => {
    const searchVal = this.props.selectItems.find(
      i => i.id === this.props.startValue
    );
    if (searchVal) {
      return this.props.startValue;
    }
    return null;
  };

  getSelectValueTitle = () => {
    if (this.state.value === null) {
      return this.state.titleSelectAll;
    }
    return this.props.selectItems.find(i => i.id === this.state.value).title;
  };

  changeValue = async (event, newValue) => {
    event.preventDefault();
    this.setState({ value: newValue });
  };

  render() {
    return (
      <div className="form-group btn-group pull-right">
        <button
          type="button"
          className="btn btn-default dropdown-toggle"
          data-toggle="dropdown"
          title={this.state.titleSelectAll}
          aria-expanded="false"
        >
          {this.getSelectValueTitle()}
        </button>
        <ul className="dropdown-menu" role="menu">
          <li className={this.state.value === null ? 'active' : ''}>
            <a href="" onClick={e => this.changeValue(e, null)}>
              {t('Все операции')}
            </a>
          </li>
          {this.props.selectItems.map(pointsTypeItem => (
            <li
              key={`PointsTypeIdSelectItem${pointsTypeItem.id}`}
              className={this.state.value === pointsTypeItem.id ? 'active' : ''}
            >
              <a href="" onClick={e => this.changeValue(e, pointsTypeItem.id)}>
                {pointsTypeItem.title}
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

PointsTypeIdSelect.propTypes = {
  startValue: PropTypes.number.isRequired,
  selectItems: PropTypes.arrayOf(PropTypes.shape).isRequired,
  handleChangeValue: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  selectItems: _.sortBy(
    getItemFromRefList(state, 'userPointsTypesNew'),
    'title'
  )
});

export default withRouter(connect(mapStateToProps)(PointsTypeIdSelect));



// WEBPACK FOOTER //
// ./src/components/Rating/RatingPointHistoryTable/inputs/PointsTypeIdSelect.js